export enum FiChatConversationMessageType {
    Common = 0,
    Deleted = 1,
    GroupStart = 2,
    GroupLeave = 3,
    GroupRename = 4, // Content contains new group conversation name
    GroupAddUser = 5, // Content contains added user's name
    GroupRemoveUser = 6, // Content contains removed user's name
    UserDeleted = 7, // user, who participated in group conversation, was physically deleted
}
